import produce from 'immer';

import {
  CREATE_CREDENTIAL_FAILURE,
  CREATE_CREDENTIAL_SUCCESS,
  DELETE_CREDENTIAL_FAILURE,
  DELETE_CREDENTIAL_SUCCESS,
  FETCH_CREDENTIAL_FAILURE,
  FETCH_CREDENTIAL_LIST_FAILURE,
  FETCH_CREDENTIAL_LIST_SUCCESS,
  FETCH_CREDENTIAL_SUCCESS,
  FETCH_EXTERNAL_SOURCE_LIST_FAILURE,
  FETCH_EXTERNAL_SOURCE_LIST_SUCCESS,
} from '@actions/apiCredential';

const initialState: ICredentialStore = {
  credentialList: null,
  currentCredential: null,
  error: null,
  credential: null,
  externalSourceList: null,
};

export default (state: ICredentialStore = initialState, action: any) =>
  produce(state, (draftState: ICredentialStore) => {
    switch (action.type) {
      case CREATE_CREDENTIAL_SUCCESS:
        draftState.credential = action.response;
        draftState.error = null;

        return;
      case FETCH_CREDENTIAL_LIST_SUCCESS:
      case DELETE_CREDENTIAL_SUCCESS:
        draftState.credentialList = action.response;
        draftState.error = null;

        return;

      case FETCH_CREDENTIAL_SUCCESS:
        draftState.currentCredential = action.response;
        draftState.error = null;

        return;

      case FETCH_EXTERNAL_SOURCE_LIST_SUCCESS:
        draftState.externalSourceList = action.response;
        draftState.error = null;

        return;

      case CREATE_CREDENTIAL_FAILURE:
      case FETCH_CREDENTIAL_LIST_FAILURE:
      case DELETE_CREDENTIAL_FAILURE:
      case FETCH_CREDENTIAL_FAILURE:
      case FETCH_EXTERNAL_SOURCE_LIST_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
